import {
  Autocomplete,
  Alert,
  Snackbar,
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  InputAdornment,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import { Box, Stack } from "@mui/system";
import { useState, useEffect } from "react";
import { QuarterlySpeedGoalsEndPointLogic } from "../../../../../../logic/AssetManagement/Health/Quarterly Website Speed Goals/QuarterlySpeedGoalsEndPointLogic";
import store from "../../../../../../store";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../../features/userSlice";
import { QuarterlyGoalsAlert } from "./QuarterlyGoalsAlert";
import { useSelector } from "react-redux";
import { setIsApiSuccessful } from "../../../../../../features/pageSpeedPerformanceSlice";
import { NumericFormat } from "react-number-format";

interface CreateSetNewModalProps {
  tableData: any;
  onCloseModal: any;
  quarterlyGoalsData: any;
  setQuarterlyGoalsData: any;
}
const quateryear = [
  { label: "Q1" },
  { label: "Q2" },
  { label: "Q3" },
  { label: "Q4" },
];

const currentYear = new Date().getFullYear(); // Get the current year
const getCurrentQuarter = () => {
  const month = new Date().getMonth(); // 0-11
  return `Q${Math.floor(month / 3) + 1}`; // Q1, Q2, Q3, Q4
};
const years = Array.from({ length: 6 }, (_, i) => currentYear + i).reverse();
export default function CreateSetNewGoal({
  tableData,
  onCloseModal,
  setQuarterlyGoalsData,
  quarterlyGoalsData,
}: CreateSetNewModalProps) {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const { selectedSharedUid } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [, setError] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [quarter, setQuarter] = useState(getCurrentQuarter()) as any;
  const [year, setYear] = useState(currentYear.toString()) as any;
  const [mobileLCP, setMobileLCP] = useState("");
  const [mobileINP, setMobileINP] = useState("");
  const [mobileCLS, setMobileCLS] = useState("");
  const [mobileFCP, setMobileFCP] = useState("");
  const [mobileTTFB, setMobileTTFB] = useState("");
  const [mobileMobileSpeedScore, setMobileMobileSpeedScore] = useState("");
  const [desktopLCP, setDesktopLCP] = useState("");
  const [desktopINP, setDesktopINP] = useState("");
  const [desktopCLS, setDesktopCLS] = useState("");
  const [desktopFCP, setDesktopFCP] = useState("");
  const [desktopTTFB, setDesktopTTFB] = useState("");
  const [desktopFID, setDesktopFID] = useState("");
  const [device, setDevice] = useState<any[]>([]);
  const [lastSubmittedData, setLastSubmittedData] = useState<any>(null); //Add a state for the last submitted data
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const { openModal } = useSelector((state: any) => state.pageSpeedPerformance);
  const isApiSuccessful = useSelector(
    (state: any) => state.pageSpeedPerformance
  );

  useEffect(() => {
    if (openModal) {
      QuarterlySpeedGoalsEndPointLogic.getDevices(oauthTokenHeader, setDevice); // Get devices
    }
  }, [openModal, oauthTokenHeader]);

  const mobileDevice = device.find(
    (deviceName: any) => deviceName.device_type_name === "Mobile"
  ); // Find mobile device
  const desktopDevice = device.find(
    (deviceName: any) => deviceName.device_type_name === "Desktop"
  ); // Find desktop device

  const createNewGoal = async () => {
    const MobileData = {
      year: parseInt(year) || currentYear,
      quarter:
        parseInt(quarter.replace("Q", "")) ||
        parseInt(getCurrentQuarter().replace("Q", "")),
      device: mobileDevice?.shared_uid, // Mobile device
      largest_contentful_paint: parseFloat(mobileLCP),
      interaction_to_next_paint: parseFloat(mobileINP),
      cumulative_layout_shift: parseFloat(mobileCLS),
      first_contentful_paint: parseFloat(mobileFCP),
      time_to_first_byte: parseFloat(mobileTTFB),
      mobile_speed_score_from_ads_platform: parseInt(mobileMobileSpeedScore),
    };
    const DesktopData = {
      year: parseInt(year) || currentYear,
      quarter:
        parseInt(quarter.replace("Q", "")) ||
        parseInt(getCurrentQuarter().replace("Q", "")),
      device: desktopDevice?.shared_uid, // Desktop device
      largest_contentful_paint: parseFloat(desktopLCP),
      interaction_to_next_paint: parseFloat(desktopINP),
      cumulative_layout_shift: parseFloat(desktopCLS),
      first_contentful_paint: parseFloat(desktopFCP),
      first_input_delay: parseFloat(desktopFID),
      time_to_first_byte: parseFloat(desktopTTFB),
      mobile_speed_score_from_ads_platform: parseInt(mobileMobileSpeedScore),
    };
    try {
      if (selectedSharedUid) {
        await Promise.all([
          (await QuarterlySpeedGoalsEndPointLogic.createQuarterlySpeedGoals(
            oauthTokenHeader,
            selectedSharedUid,
            MobileData
          )) as any,
          (await QuarterlySpeedGoalsEndPointLogic.createQuarterlySpeedGoals(
            oauthTokenHeader,
            selectedSharedUid,
            DesktopData
          )) as any,
        ]);
        setLastSubmittedData({
          quarter: parseInt(quarter.replace("Q", "")), //Modified the createNewGoal function to save the submitted data before closing the modal
          year: parseInt(year),
          mobileLCP,
          mobileINP,
          mobileCLS,
          mobileFCP,
          mobileTTFB,
          mobileMobileSpeedScore,
          desktopLCP,
          desktopINP,
          desktopCLS,
          desktopFCP,
          desktopTTFB,
          desktopFID,
        });
        if (isApiSuccessful) {
          store.dispatch(
            setDisplayErrorSnackBar({
              message: "The Goals Have Been Successfully Defined",
              type: "success",
            })
          );
        }
        onCloseModal();
      } else {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "User doesn't have permissions to create Quarterly Goals",
            type: "error",
          })
        );
      }
      if (selectedSharedUid) {
        await QuarterlySpeedGoalsEndPointLogic.getQuarterlySpeedGoals(
          oauthTokenHeader,
          selectedSharedUid,
          setQuarterlyGoalsData,
          setError
        );
      }
    } catch (error) {
      setSnackbarOpen(true);
      setSnackbarMessage("error");
      console.error("Error while creating Sequence", error);
    } finally {
      onCloseModal();
      setLoading(false);
      store.dispatch(setIsApiSuccessful(false));
    }
  };

  useEffect(() => {
    if (openModal) {
      QuarterlySpeedGoalsEndPointLogic.getDevices(oauthTokenHeader, setDevice);
      // If we have last submitted data, use it to initialize the form
      if (lastSubmittedData) {
        setQuarter(`Q${lastSubmittedData.quarter}`);
        setYear(lastSubmittedData.year.toString());
        setMobileLCP(lastSubmittedData.mobileLCP);
        setMobileINP(lastSubmittedData.mobileINP);
        setMobileCLS(lastSubmittedData.mobileCLS);
        setMobileFCP(lastSubmittedData.mobileFCP);
        setMobileTTFB(lastSubmittedData.mobileTTFB);
        setMobileMobileSpeedScore(lastSubmittedData.mobileMobileSpeedScore);
        setDesktopLCP(lastSubmittedData.desktopLCP);
        setDesktopINP(lastSubmittedData.desktopINP);
        setDesktopCLS(lastSubmittedData.desktopCLS);
        setDesktopFCP(lastSubmittedData.desktopFCP);
        setDesktopTTFB(lastSubmittedData.desktopTTFB);
        setDesktopFID(lastSubmittedData.desktopFID);
      } else {
        // If no last submitted data, set default values
        setQuarter(getCurrentQuarter());
        setYear(currentYear.toString());
        setMobileLCP("");
        setMobileINP("");
        setMobileCLS("");
        setMobileFCP("");
        setMobileTTFB("");
        setMobileMobileSpeedScore("");
        setDesktopLCP("");
        setDesktopINP("");
        setDesktopCLS("");
        setDesktopFCP("");
        setDesktopTTFB("");
        setDesktopFID("");
      }
    }
  }, [openModal, oauthTokenHeader, lastSubmittedData]);

  const handleCloseCreateDialog = () => {
    onCloseModal();
  };

  const validate = async () => {
    // Validate quarter and year
    if (!quarter) {
      setSnackbarOpen(true);
      setSnackbarMessage("Please select a quarter.");
      setIsValid(false); // Validation failed
      return false; // Validation failed
    }
    if (!year) {
      setSnackbarOpen(true);
      setSnackbarMessage("Please select a year.");
      setIsValid(false); // Validation failed
      return false; // Validation failed
    }
    if (
      !mobileLCP ||
      !mobileINP ||
      !mobileCLS ||
      !mobileFCP ||
      !mobileTTFB ||
      !mobileMobileSpeedScore ||
      !desktopLCP ||
      !desktopINP ||
      !desktopCLS ||
      !desktopFCP ||
      !desktopTTFB ||
      !desktopFID
    ) {
      // Validate all fields
      setSnackbarOpen(true);
      setSnackbarMessage("All fields are mandatory.");
      setIsValid(false); // Validation failed
      return false; // Validation failed
    }
    if (mobileMobileSpeedScore) {
      // Validate mobile Mobile Speed Score
      const score = parseInt(mobileMobileSpeedScore, 10); // Convert the score to an integer
      if (score < 1 || score > 10) {
        setSnackbarOpen(true);
        setSnackbarMessage("Mobile Speed Score must be between 1 and 10.");
        setIsValid(false); // Validation failed
        return false; // Validation failed
      }
    }

    // Check if the quarterly goal is unique
    const selectedQuarter = parseInt(quarter.replace("Q", "")); // Convert 'Q1', 'Q2', etc. to 1, 2, etc.
    const selectedYear = parseInt(year); // Convert the year string to a number
    // Check if the quarterly goal is unique
    const isQuarterlyGoalUnique = tableData?.every((goal: any) => {
      const [goalQuarter, goalYear] = goal?.period?.split("/").map(Number); // Split '3/2006' into [3, 2006]
      return !(goalQuarter === selectedQuarter && goalYear === selectedYear); // Check if the quarter, year, and device match
    });
    if (!isQuarterlyGoalUnique && tableData !== undefined) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Goal already exists.",
          type: "error",
        })
      );
      setIsValid(false);
      return false;
    }

    setIsValid(true); // Validation passed
    return true; // Validation passed
  };

  const handleCreateNewGoal = async () => {
    const isFormValid = await validate();
    if (!isFormValid) return; // Only proceed if the form is valid
    try {
      setLoading(true);
      await createNewGoal();
      onCloseModal();
    } catch (error) {
      console.error("Error while creating Sequence", error);
    } finally {
      setLoading(false);
    }
  };

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={
            !isValid || quarterlyGoalsData?.reason !== "success"
              ? "error"
              : "success"
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };
  useEffect(() => {
    if (openModal) {
      setSelectedOption("copy");
      const periods = Array.from(
        new Set(tableData?.map((goal: any) => goal.period) || [])
      ) // Get and sort periods to get the latest one
        .sort((a: any, b: any) => {
          const [quarterA, yearA] = a.split("/").map(Number);
          const [quarterB, yearB] = b.split("/").map(Number);
          return yearB - yearA || quarterB - quarterA;
        });
      const latestPeriod = periods[0]; // Get the most recent period
      if (latestPeriod) {
        const mobileData = tableData?.find(
          (goal: any) =>
            goal.period === latestPeriod && goal.device === "Mobile"
        );
        const desktopData = tableData?.find(
          (goal: any) =>
            goal.period === latestPeriod && goal.device === "Desktop"
        );

        // If both mobile and desktop data exist for this period
        if (mobileData && desktopData) {
          // Set mobile metrics
          setMobileLCP(mobileData.largest_contentful_paint?.toString() || "");
          setMobileINP(mobileData.interaction_to_next_paint?.toString() || "");
          setMobileCLS(mobileData.cumulative_layout_shift?.toString() || "");
          setMobileFCP(mobileData.first_contentful_paint?.toString() || "");
          setMobileTTFB(mobileData.time_to_first_byte?.toString() || "");
          setMobileMobileSpeedScore(
            mobileData.mobile_speed_score_from_ads_platform?.toString() || ""
          );

          // Set desktop metrics
          setDesktopLCP(desktopData.largest_contentful_paint?.toString() || "");
          setDesktopINP(
            desktopData.interaction_to_next_paint?.toString() || ""
          );
          setDesktopCLS(desktopData.cumulative_layout_shift?.toString() || "");
          setDesktopFCP(desktopData.first_contentful_paint?.toString() || "");
          setDesktopFID(desktopData.first_input_delay?.toString() || "");
          setDesktopTTFB(desktopData.time_to_first_byte?.toString() || "");
        }
      }
    }
  }, [openModal, tableData]);
  return (
    <>
      {renderSnackbar()}
      <Dialog
        open={openModal}
        PaperProps={{
          sx: { width: "900px", maxWidth: "900px", overflow: "hidden" },
        }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px", overflow: "hidden" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Set New Quarterly Goals
          </DialogTitle>
          {/* period */}
          <Box>
            <DialogTitle
              sx={{
                fontSize: "16px",
                padding: "0px 0px 8px 0px",
                fontWeight: "400",
              }}
            >
              Period
            </DialogTitle>
            <Stack flexDirection={"row"} gap={2}>
              <Box>
                <Autocomplete
                  disablePortal
                  options={quateryear.map((quater) => quater.label)}
                  sx={{ width: 418 }}
                  size="small"
                  value={quarter}
                  onChange={(_, value) => setQuarter(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Quarter *"
                      color="secondary"
                    />
                  )}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    letterSpacing: "0.4",
                    color: "#00000099",
                    marginTop: "4px",
                    marginLeft: "16px",
                  }}
                >
                  Pick a quarter that is later than the current date
                </Typography>
              </Box>
              <Box>
                <Autocomplete
                  disablePortal
                  options={years}
                  sx={{ width: 418 }}
                  size="small"
                  value={year}
                  onChange={(_, value) => setYear(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="Year *" color="secondary" />
                  )}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    letterSpacing: "0.4",
                    color: "#00000099",
                    marginTop: "4px",
                    marginLeft: "16px",
                  }}
                >
                  Pick a year that is later than the current date
                </Typography>
              </Box>
            </Stack>
          </Box>
          <QuarterlyGoalsAlert
            show={
              !(
                mobileCLS ||
                mobileFCP ||
                mobileINP ||
                mobileLCP ||
                mobileMobileSpeedScore ||
                mobileTTFB ||
                desktopCLS ||
                desktopFCP ||
                desktopINP ||
                desktopLCP ||
                desktopTTFB
              )
            }
          />
          <Box marginTop={2}>
            <DialogTitle
              sx={{
                fontSize: "16px",
                padding: "0px 0px 8px 0px",
                fontWeight: "400",
              }}
            >
              Data Set
            </DialogTitle>
            <Stack flexDirection={"row"} gap={2}>
              <Box>
                <Stack direction="row" gap={2}>
                  <FormControlLabel
                    value="scratch"
                    control={<Radio color="secondary" />}
                    checked={selectedOption === "scratch"}
                    onChange={() => {
                      setSelectedOption("scratch");
                      // Clear all fields when switching to "Start from scratch"
                      setMobileLCP("");
                      setMobileINP("");
                      setMobileCLS("");
                      setMobileFCP("");
                      setMobileTTFB("");
                      setMobileMobileSpeedScore("");
                      setDesktopLCP("");
                      setDesktopINP("");
                      setDesktopCLS("");
                      setDesktopFCP("");
                      setDesktopFID("");
                      setDesktopTTFB("");
                    }}
                    label="Start from scratch"
                  />
                  <FormControlLabel
                    value="copy"
                    control={<Radio color="secondary" />}
                    checked={selectedOption === "copy"}
                    label="Copy from"
                    onChange={() => {
                      setSelectedOption("copy");
                      // Get the last selected period or default to the most recent one
                      const periods = Array.from(
                        new Set(
                          tableData?.map((goal: any) => goal.period) || []
                        )
                      ).sort((a: any, b: any) => {
                        const [quarterA, yearA] = a.split("/").map(Number);
                        const [quarterB, yearB] = b.split("/").map(Number);
                        return yearB - yearA || quarterB - quarterA;
                      });
                      const selectedPeriod = periods[0]; // Get the most recent period

                      if (selectedPeriod) {
                        const mobileData = tableData?.find(
                          (goal: any) =>
                            goal.period === selectedPeriod &&
                            goal.device === "Mobile"
                        );
                        const desktopData = tableData?.find(
                          (goal: any) =>
                            goal.period === selectedPeriod &&
                            goal.device === "Desktop"
                        );

                        // If both mobile and desktop data exist for this period
                        if (mobileData && desktopData) {
                          // Mobile metrics
                          setMobileLCP(
                            mobileData.largest_contentful_paint?.toString() ||
                              ""
                          );
                          setMobileINP(
                            mobileData.interaction_to_next_paint?.toString() ||
                              ""
                          );
                          setMobileCLS(
                            mobileData.cumulative_layout_shift?.toString() || ""
                          );
                          setMobileFCP(
                            mobileData.first_contentful_paint?.toString() || ""
                          );
                          setMobileTTFB(
                            mobileData.time_to_first_byte?.toString() || ""
                          );
                          setMobileMobileSpeedScore(
                            mobileData.mobile_speed_score_from_ads_platform?.toString() ||
                              ""
                          );

                          // Desktop metrics
                          setDesktopLCP(
                            desktopData.largest_contentful_paint?.toString() ||
                              ""
                          );
                          setDesktopINP(
                            desktopData.interaction_to_next_paint?.toString() ||
                              ""
                          );
                          setDesktopCLS(
                            desktopData.cumulative_layout_shift?.toString() ||
                              ""
                          );
                          setDesktopFCP(
                            desktopData.first_contentful_paint?.toString() || ""
                          );
                          setDesktopFID(
                            desktopData.first_input_delay?.toString() || ""
                          );
                          setDesktopTTFB(
                            desktopData.time_to_first_byte?.toString() || ""
                          );
                        }
                      }
                    }}
                  />
                  <Autocomplete
                    disablePortal
                    options={Array.from(
                      new Set(tableData?.map((goal: any) => goal.period) || [])
                    ).sort((a: any, b: any) => {
                      const [quarterA, yearA] = a.split("/").map(Number);
                      const [quarterB, yearB] = b.split("/").map(Number);
                      return yearB - yearA || quarterB - quarterA;
                    })}
                    defaultValue={
                      tableData && tableData.length > 0
                        ? Array.from(
                            new Set(tableData?.map((goal: any) => goal.period))
                          ).sort((a: any, b: any) => {
                            const [quarterA, yearA] = a.split("/").map(Number);
                            const [quarterB, yearB] = b.split("/").map(Number);
                            return yearB - yearA || quarterB - quarterA;
                          })[0]
                        : null
                    }
                    onChange={(_, value) => {
                      if (value) {
                        const mobileData = tableData?.find(
                          (goal: any) =>
                            goal.period === value && goal.device === "Mobile"
                        );
                        const desktopData = tableData?.find(
                          (goal: any) =>
                            goal.period === value && goal.device === "Desktop"
                        );
                        if (mobileData && desktopData) {
                          setMobileLCP(
                            mobileData.largest_contentful_paint?.toString() ||
                              ""
                          ); // Mobile metrics
                          setMobileINP(
                            mobileData.interaction_to_next_paint?.toString() ||
                              ""
                          );
                          setMobileCLS(
                            mobileData.cumulative_layout_shift?.toString() || ""
                          );
                          setMobileFCP(
                            mobileData.first_contentful_paint?.toString() || ""
                          );
                          setMobileTTFB(
                            mobileData.time_to_first_byte?.toString() || ""
                          );
                          setMobileMobileSpeedScore(
                            mobileData.mobile_speed_score_from_ads_platform?.toString() ||
                              ""
                          );
                          setDesktopLCP(
                            desktopData.largest_contentful_paint?.toString() ||
                              ""
                          ); // Desktop metrics
                          setDesktopINP(
                            desktopData.interaction_to_next_paint?.toString() ||
                              ""
                          );
                          setDesktopCLS(
                            desktopData.cumulative_layout_shift?.toString() ||
                              ""
                          );
                          setDesktopFCP(
                            desktopData.first_contentful_paint?.toString() || ""
                          );
                          setDesktopFID(
                            desktopData.first_input_delay?.toString() || ""
                          );
                          setDesktopTTFB(
                            desktopData.time_to_first_byte?.toString() || ""
                          );
                        }
                      } else {
                        setMobileLCP(""); // Clear all fields when no period is selected
                        setMobileINP("");
                        setMobileCLS("");
                        setMobileFCP("");
                        setMobileTTFB("");
                        setMobileMobileSpeedScore("");
                        setDesktopLCP("");
                        setDesktopINP("");
                        setDesktopCLS("");
                        setDesktopFCP("");
                        setDesktopFID("");
                        setDesktopTTFB("");
                      }
                    }}
                    sx={{ width: 418 }}
                    size="small"
                    disabled={selectedOption !== "copy"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Period"
                        color="secondary"
                      />
                    )}
                  />
                </Stack>
              </Box>
            </Stack>
          </Box>
          {/* mobile */}
          <Box marginTop={2}>
            <DialogTitle
              sx={{
                fontSize: "16px",
                padding: "0px 0px 8px 0px",
                fontWeight: "400",
              }}
            >
              Mobile
            </DialogTitle>
            <Stack gap={2}>
              <Stack flexDirection={"row"} gap={2}>
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="LCP"
                  color="secondary"
                  size="small"
                  required
                  value={mobileLCP}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">s</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setMobileLCP(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="INP"
                  color="secondary"
                  size="small"
                  required
                  value={mobileINP}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">ms</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setMobileINP(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="CLS"
                  color="secondary"
                  size="small"
                  required
                  value={mobileCLS}
                  decimalScale={2}
                  thousandSeparator=","
                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="start">ms</InputAdornment>
                  //   ),
                  // }} {/* removed ms as per current requirements(https://optival.atlassian.net/browse/GR-21472) */}
                  onValueChange={(values) => {
                    setMobileCLS(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
              </Stack>
              <Stack flexDirection={"row"} gap={2}>
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="FCP"
                  color="secondary"
                  size="small"
                  required
                  value={mobileFCP}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">s</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setMobileFCP(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="TTFB"
                  color="secondary"
                  size="small"
                  required
                  value={mobileTTFB}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">s</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setMobileTTFB(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="Mobile Speed Score"
                  color="secondary"
                  size="small"
                  required
                  value={mobileMobileSpeedScore}
                  decimalScale={2}
                  thousandSeparator=","
                  onValueChange={(values) => {
                    setMobileMobileSpeedScore(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
              </Stack>
            </Stack>
          </Box>
          {/* desktop */}
          <Box marginTop={2}>
            <DialogTitle
              sx={{
                fontSize: "16px",
                padding: "0px 0px 8px 0px",
                fontWeight: "400",
              }}
            >
              Desktop
            </DialogTitle>
            <Stack gap={2}>
              <Stack flexDirection={"row"} gap={2}>
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="LCP"
                  color="secondary"
                  size="small"
                  required
                  value={desktopLCP}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">s</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setDesktopLCP(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="INP"
                  color="secondary"
                  size="small"
                  required
                  value={desktopINP}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">ms</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setDesktopINP(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="CLS"
                  color="secondary"
                  size="small"
                  required
                  value={desktopCLS}
                  decimalScale={2}
                  thousandSeparator=","
                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="start">ms</InputAdornment>
                  //   ),
                  // }} {/* removed ms as per current requirements(https://optival.atlassian.net/browse/GR-21472) */}
                  onValueChange={(values) => {
                    setDesktopCLS(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
              </Stack>
              <Stack flexDirection={"row"} gap={2}>
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="FCP"
                  color="secondary"
                  size="small"
                  required
                  value={desktopFCP}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">s</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setDesktopFCP(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="FID"
                  color="secondary"
                  size="small"
                  required
                  value={desktopFID}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">ms</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setDesktopFID(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
                <NumericFormat
                  id="outlined-multiline-flexible"
                  customInput={TextField}
                  fullWidth
                  label="TTFB"
                  color="secondary"
                  size="small"
                  required
                  value={desktopTTFB}
                  decimalScale={2}
                  thousandSeparator=","
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">s</InputAdornment>
                    ),
                  }}
                  onValueChange={(values) => {
                    setDesktopTTFB(values.value);
                  }}
                  sx={{
                    width: "274px",
                  }}
                />
              </Stack>
            </Stack>
          </Box>
          <Typography
            sx={{
              fontSize: "12px",
              lineHeight: "20px",
              letterSpacing: "0.4",
              color: "#00000099",
              marginTop: "16px",
            }}
          >
            All fields are mandatory.
          </Typography>
          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" onClick={handleCloseCreateDialog}>
              CANCEL
            </Button>
            <Button
              data-tracker="164"
              variant="contained"
              color="secondary"
              loadingPosition="end"
              loading={loading}
              endIcon={loading && <SaveIcon />}
              onClick={handleCreateNewGoal}
              disabled={
                !quarter ||
                !year ||
                !mobileLCP ||
                !mobileINP ||
                !mobileCLS ||
                !mobileFCP ||
                !mobileTTFB ||
                !mobileMobileSpeedScore ||
                !desktopLCP ||
                !desktopINP ||
                !desktopCLS ||
                !desktopFCP ||
                !desktopTTFB ||
                !desktopFID
              }
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                gap={1}
              >
                SET GOALS <CheckIcon fontSize="small" />
              </Stack>
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
}
